import request from '../utils/request';

class TicketService {

    static async createTicket(params) {
        return request.postJson(`${process.env.REACT_APP_KWM_ENDPOINT}/tickets`,
            {
                body: params
            }
        );
    }

}
export default TicketService;
